// @flow

export { default } from './OutsideClickable';
